import queryString from 'query-string'
import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/**
 * Функция (hook) для считывания, замены значения и добавления GET параметра в адресную строку.
 * A function (hook) to read, replace the value, and add a GET parameter to the address bar.
 *
 * @returns Возвращает объект со следующими параметрами:
 *          params - объект с GET параметрами.
 *          replaceParams - функция замены значений имеющихся GET параметров
 *          pushParams - функция добавления новых GET параметров
 *          Returns an object with the following parameters:
 *          params - an object with GET parameters.
 *          replaceParams - function to replace the values of existing GET parameters
 *          pushParams - function for adding new GET parameters
 */

const useQueryParams = () => {
  const { search } = useLocation()
  const history = useHistory()

  const query = useMemo(
    () =>
      queryString.parse(search, {
        parseBooleans: true,
        arrayFormat: 'bracket',
      }),
    [search],
  )

  const setQuery = useCallback((params = {}, type) => {
    const { withPathname = null, ...rest } = params

    history[type]({
      pathname: withPathname || global.location.pathname,
      search: queryString.stringify(rest, {
        arrayFormat: 'bracket',
      }),
    })
  }, [])

  return {
    query,
    setQuery: (params, type = 'replace') => setQuery(params, type),
  }
}
export default useQueryParams
